import { render } from "./Cookies.vue?vue&type=template&id=c4b43736&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=c4b43736&lang=scss&scoped=true"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b43736"]])

export default __exports__